module.exports = __webpack_public_path__ + "20d7d2ba5ee24cfa59c296b578db8c6e.svg";